export const APPLE_ENHANCED_DESIGN_IMAGES_NAMESPACE =
  'appleEnhancedDesign.images';

export const APPLE_ENHANCED_DESIGN_FEATURED_ACTIONS_NAMESPACE =
  'appleEnhancedDesign.featuredActions';

export const ENHANCED_GENERIC_SECTION_ID = 'enhanced-generic-section';

export const ENHANCED_EVENT_TICKET_SECTION_ID = 'enhanced-event-ticket-section';

export const FEATURED_ACTIONS_SECTION_ID = 'featured-actions-section';

export const APPLE_ENHANCED_SECTION_IDS = {
  generic: ENHANCED_GENERIC_SECTION_ID,
  eventTicket: ENHANCED_EVENT_TICKET_SECTION_ID,
} as const;
